import { logoPhone } from './logo-phone';
import { logoDesktop } from './logo-tablet-desktop';
import { bottomLeftArc } from '../../bottom-left-arc';
import { bottomRightArc } from '../../bottom-right-arc';
import { check } from '../../check';
import { cookies } from '../../cookies';
import { cross } from '../../cross';
import { topLeftArc } from '../../top-left-arc';
import { topRightArc } from '../../top-right-arc';
export var genistarLight = {
  logoDesktop: logoDesktop,
  logoPhone: logoPhone,
  check: check,
  cookies: cookies,
  cross: cross,
  topLeftArc: topLeftArc,
  bottomRightArc: bottomRightArc,
  topRightArc: topRightArc,
  bottomLeftArc: bottomLeftArc
};